import { useNavigate } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";

import { LogoLettersBlack, InstagramBlack, LinkedInBlack } from "../../../assets/images";

import {
  Container,
  Inner,
  LeftSide,
  FooterLogo,
  SocialRow,
  SocialLink,
  SocialIcon,
  Copyright,
  RightSide,
  LinkColumn,
  FooterLink,
  FooterLinkBold,
} from "./styles";

const FooterSection = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Inner>
        <LeftSide>
          <FooterLogo src={LogoLettersBlack} alt="JackedRabbit" />
          <SocialRow>
            <SocialLink href="https://www.instagram.com/jacked.rabbit/" target="_blank" rel="noreferrer">
              <SocialIcon src={InstagramBlack} alt="Instagram" />
            </SocialLink>
            <SocialLink href="https://www.linkedin.com/company/jackedrabbit/" target="_blank" rel="noreferrer">
              <SocialIcon src={LinkedInBlack} alt="LinkedIn" />
            </SocialLink>
          </SocialRow>
          <Copyright>JackedRabbit 2026 © All rights reserved</Copyright>
        </LeftSide>

        <RightSide>
          <LinkColumn>
            <Link to="#hero" smooth style={{ textDecoration: "none" }}>
              <FooterLink>Home</FooterLink>
            </Link>
            <span onClick={() => navigate("/signup")} style={{ cursor: "pointer" }}>
              <FooterLink>Become a member</FooterLink>
            </span>
            <Link to="#become-a-partner" smooth style={{ textDecoration: "none" }}>
              <FooterLink>List your business</FooterLink>
            </Link>
          </LinkColumn>

          <LinkColumn>
            <a href="mailto:support@jackedrabbitgyms.com" style={{ textDecoration: "none" }}>
              <FooterLink>Contact Us</FooterLink>
            </a>
          </LinkColumn>
        </RightSide>
      </Inner>
    </Container>
  );
};

export default FooterSection;
